import { SortDirection } from 'constants/SortDirection';
import { runInAction } from 'mobx';
import { buildWhereFilter, get, getCount, getPage, patch, post } from 'stores/_services/dataService';
import { getConditions, getListConditions } from 'stores/_services/filterService';
import { SortDirection } from 'constants/SortDirection';
import { runInAction } from 'mobx';
import { buildWhereFilter, get, getPage, patch, post } from 'stores/_services/dataService';
import { getConditions, getListConditions } from 'stores/_services/filterService';
import BaseListStore from 'stores/BaseListStore';
import DeviceGroupStore, { IDeviceGroup } from 'stores/deviceGroup/DeviceGroupStore';
import { SortDirection } from 'constants/SortDirection';
import { IDataFetchOptions } from '../../types';
import { getConditions, getListConditions } from 'stores/_services/filterService';
import { post, getCount, getPage, get, patch, buildWhereFilter } from 'stores/_services/dataService';
import { runInAction } from 'mobx';

interface IGetDeviceGroupsArgs extends IDataFetchOptions {
    deviceGroupGroupId?: string;
}

const SEARCH_FIELDS = ['name'];

export default class DeviceGroupListStore extends BaseListStore<DeviceGroupStore> {
    constructor() {
        super({
            itemStore: DeviceGroupStore,
            sortBy: 'name',
            sortDirection: SortDirection.ASC
        });
    }

    async getDeviceGroup(deviceGroupId: string): Promise<void> {
        const { data } = await get(`deviceGroups/${deviceGroupId}`);
        this._updateData(data);
    }

    async getDeviceGroups({ ...args }: IGetDeviceGroupsArgs = {}): Promise<void> {
        const shouldReset = this._updateListState(args);
        const conditions = getConditions(this.filter);

        const options = {
            filter: {
                limit: this.limit,
                skip: this.skip,
                searchFields: SEARCH_FIELDS,
                where: conditions,
                order: [this.sort, `name ${this.sortDirection}`]
            }
        };

        const { data } = await getPage('deviceGroups', options);

        if (shouldReset) {
            this.clear();
        }

        runInAction(() => {
            this._updateData(data);
            this._updateIds(data, this.skip);
            this._updateCount(data);
        });
    }

    async getAssignedTypeGroups() {
        const options = {
            filter: {
                where: { deviceType: { neq: null } },
                limit: 4,
                skip: 0,
                order: ['deviceType DESC', 'id ASC']
            }
        };
        const { data } = await getPage('deviceGroups', options);
        return data.filter((i: IDeviceGroup) => i.deviceType?.length !== 0);
    }

    async existsDeviceGroupName(name: string, id: string): Promise<boolean> {
        const options = {
            filter: {
                where: { name: name }
            }
        };
        const { data } = await get('deviceGroups', options);
        return !!data.length && !data.find((i) => i.id === id);
    }

    async saveDeviceGroup(payload: any): Promise<IDeviceGroup | undefined> {
        const exists = await this.existsDeviceGroupName(payload?.name, payload?.id);
        if (exists) {
            throw new Error('Device Group with this name already exists.');
        }

        const { data } = await patch('/deviceGroups', payload);
        return data;
    }

    async deleteDeviceGroups(itemId?: string): Promise<void> {
        const conditions = getListConditions(itemId ? [itemId] : this.selectedIdList, this.filter);

        const where = buildWhereFilter({
            where: conditions,
            searchFields: SEARCH_FIELDS
        });

        await post('deviceGroups/delete', { where });

        this.deselectAll();
        this.resetFilter();
        await this.getDeviceGroups({ reset: true });
    }
}
